import * as React from 'react';
import {
  Dimensions,
  Platform,
  KeyboardAvoidingView,
  StyleSheet,
  View,
  ScrollView,
  Text
} from 'react-native';
import {
  withSafeAreaInsets,
  WithSafeAreaInsetsProps
} from 'react-native-safe-area-context';
import { translate } from 'secullum-i18n';
import { Card, Modal, isTablet } from 'secullum-react-native-ui';
import { getTheme } from '../../shared/modules/layout';
import { isEdgeToEdge } from '../modules/deviceInfo';
import { DadosFuncionario } from '../modules/types';
import SolicitarAjudaForm from './SolicitarAjudaForm';

interface Props {
  dadosFuncionario?: DadosFuncionario;
  empresaBancoId: string;
  nomeEmpresa: string;
  caminhoTermoPrivacidade: string;
  onClose: () => void;
  onNavegar?: () => void;
  onErroConexao?: (mensagem: string, onTentarNovamente: () => void) => void;
}

class ModalSolicitarAjuda extends React.Component<
  Props & WithSafeAreaInsetsProps
> {
  render() {
    const ios = Platform.OS === 'ios';

    let alturaMaxima = Dimensions.get('window').height - 100;

    if (isEdgeToEdge()) {
      const { top = 0, bottom = 0 } = this.props.insets ?? {};

      alturaMaxima = alturaMaxima - top - bottom;
    }

    return (
      <Modal visible onRequestClose={() => true}>
        <KeyboardAvoidingView
          style={
            ios ? [styles.container, { maxHeight: alturaMaxima }] : undefined
          }
          contentContainerStyle={
            ios ? undefined : [styles.container, { maxHeight: alturaMaxima }]
          }
          behavior={ios ? 'padding' : 'position'}
          keyboardVerticalOffset={ios ? 30 : -100}
          enabled
        >
          <Card style={styles.modal}>
            <ScrollView>
              <Card.Section>
                <View style={styles.cardHeader}>
                  <Text style={styles.title}>
                    {translate('Solicitar Ajuda')}
                  </Text>
                </View>
                <SolicitarAjudaForm {...this.props} />
              </Card.Section>
            </ScrollView>
          </Card>
        </KeyboardAvoidingView>
      </Modal>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  cardHeader: {
    paddingBottom: 10,
    flexDirection: 'row'
  },
  title: {
    flexDirection: 'row',
    fontSize: isTablet() ? 28 : 18,
    fontWeight: 'bold',
    color: theme.textColor3,
    alignSelf: 'flex-start'
  },
  modal: {
    marginHorizontal: 20,
    justifyContent: 'center',
    flexDirection: 'row',
    top: 30
  },
  container: {
    width: Dimensions.get('window').width
  }
});

export default withSafeAreaInsets(ModalSolicitarAjuda);
